var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('van-field',{attrs:{"rows":"8","label":_vm.$t('CourseHome.课程介绍'),"type":"textarea","placeholder":_vm.$t('Home.请输入课程介绍'),"show-word-limit":""},model:{value:(_vm.describes),callback:function ($$v) {_vm.describes=$$v},expression:"describes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }